<div class="carousel-container">
  <div class="image-container">
    <img 
      *ngIf="currentImage$ | async as image" 
      [src]="image.downloadUrl" 
      [alt]="image.name"
      class="carousel-image">
    <div *ngIf="!(currentImage$ | async)" class="no-images">
      No images available
    </div>
    <div 
      class="button circle-button arrow left" 
      [ngClass]="{'disabled': currentIndex === 0}"
      (click)="navigate(-1)"
      aria-label="Previous image">
      <img src="/assets/icons/arrow_left.svg" class="icon-white" alt="">
    </div>
    <div 
      class="button circle-button arrow right" 
      [ngClass]="{'disabled': currentIndex === imageFiles.length - 1}"
      (click)="navigate(1)"
      aria-label="Next image">
      <img src="/assets/icons/arrow_right.svg" class="icon-white" alt="">
    </div>
  </div>
</div>

<div class="image-counter" *ngIf="imageFiles.length > 0">
  {{ currentIndex + 1 }} / {{ imageFiles.length }}
</div>